import React from 'react';

import Payments from 'features/admin/ui/Payments/Payments';
import AddPaymentButton from 'features/admin/ui/AddPaymentButton/AddPaymentButton';

import useShowAddPaymentButton from '../../model/useShowAddPaymentButton';

const AdminPaymentsScreen: React.FC = () => {
    const showAddPayment = useShowAddPaymentButton();

    return (
        <>
            <Payments />
            {showAddPayment && <AddPaymentButton />}
        </>
    );
};

export default AdminPaymentsScreen;
